import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";

import type FindRangeSelectFilter from "../../../models/RangeSelectFilter/RangeSelectFilter";
import type { IFilterViewBaseProps } from "../../../types/filterInstance";
import { getFormattedRangeValue } from "../../../utils/rangeValueFormatters";

const RangeSelectFilterResult = ({
    filter: {
        options: { formatValue, buckets },
    },
    value,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindRangeSelectFilter>): ReactElement | null => {
    if (!value) {
        return null;
    }

    return (
        <Flex>
            <FiltersChip
                text={getFormattedRangeValue(formatValue, buckets, value)}
                hideActionButton={!isActionEnabled}
                chipStatus={onGetLifecycleStatus?.(value)}
                onClose={() => {
                    onFilterValueRemove?.();
                    onFilterUpdate();
                }}
            />
        </Flex>
    );
};

export default RangeSelectFilterResult;
